module.exports = __webpack_public_path__ + "img/tingchejiayou.af6892fc.png";